import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type I06SparkleAppointment = RenderingProps<
  DynamicPlaceholderParams & TranslationOptionsParams & AnchorTargetParams
>;
